<template>
    <div class="form-check form-switch flex justify-content-end align-items-end" @click.prevent="toggle">
        <input
            :id="uuid" 
            class="form-check-input cursor-pointer" 
            type="checkbox" 
            role="switch"
            :checked="isChecked"
            :disabled="disabled"
            @change="onChange"
        >
        <label
            class="form-check-label" 
            :for="uuid" 
            :class="[labelClass, `${disabled ? 'disabled' : ''}`]"
        >
            <slot />
        </label>
    </div>
</template>

<script>
import { wait } from "@/plugins/index";
import { simpleUniqueID } from "@/utils/strings";

/**
 * @group UI Components / Forms
 * A basic checkbox implementation with the default styling and label
 * <br>
 * ![image](https://cdn.filestackcontent.com/baI9CUMSfe0JrgTfYIr1)

 * `FormSwitch value="future">Save for the future</FormSwitch>`
 */
export default {
    name: "FormSwitch",

    props: {
        // Define the checkbox value. Same as with normal checkbox input.
        modelValue: { 
            type: Boolean,
            default: false,
            required: true,
        },

        // Define a class or classes for the checkbox label
        labelClass: {
            type: String,
            default: "undefined",
        },
        trueValue: {
            default: true,
            type: Boolean,
        },
        falseValue: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            uuid: undefined,
        };
    },

    computed: {
        isChecked() {
            return this.modelValue === this.trueValue;
        },
    },

    mounted() {
        /**
         * Set this only on the browser. There is a wierd behaviour where Nuxt rerenders the page (Server and Client) partially
         * and uuid become different for input and label html tags.
         */
        this.uuid = this.modelValue + "_" + simpleUniqueID();
    },

    methods: {
        onChange(e) {
            wait(200).then(() => {
                this.$emit("change", e);
            });
        },

        toggle() {
            if (this.disabled) return;

            const newValue = this.isChecked ? this.falseValue : this.trueValue;
            this.$emit("input", newValue); // v-model compatible
        },
    },
};
</script>